/**
 * Utility for commonly used words and their plural forms.
 */
export default {
  guest: ["гість", "гостя", "гостей"],

  guestForPrice: ["гостя", "гостей", "гостей"],

  room: ["номер", "номери", "номерів"],

  roomOf: ["номера", "номерів", "номерів"],

  master: ["майстер", "майстри", "майстрів"],

  resource: ["ресурс", "ресурси", "ресурсів"],

  sellableItem: ["позиція", "позиції", "позицій"],
};
